import { render, staticRenderFns } from "./DashboardTaskByResponsible.vue?vue&type=template&id=591b04a2&scoped=true"
import script from "./DashboardTaskByResponsible.vue?vue&type=script&lang=js"
export * from "./DashboardTaskByResponsible.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "591b04a2",
  null
  
)

export default component.exports